import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import type {
  TimesheetsApprovalTotalResponseType,
  TimesheetsApprovalResponseType,
  TimesheetsApprovalUpdatedResponseType,
  TimesheetsExportDocumentType,
} from '@/api/types/response/TimesheetsResponseType'
import type { TimesheetsApprovalPayloadType } from '@/api/types/request/TimesheetsPayloadType'

/**
 * @property string apiEnd /api/timesheets/approval
 */
export default class TimesheetsApprovalApi extends AbstractApi {
  summary(start?: string, end?: string): Promise<TimesheetsApprovalTotalResponseType> {
    let url = `${this.apiEnd}/total`

    if (start && end) {
      url += `?start=${start}&end=${end}`
    }

    return httpClient.get(url)
  }

  users(date: string): Promise<TimesheetsApprovalResponseType> {
    return httpClient.get(`${this.apiEnd}?start=${date}&end=${date}`)
  }

  updateStatus(timesheets: TimesheetsApprovalPayloadType[]): Promise<TimesheetsApprovalUpdatedResponseType> {
    return httpClient.post(this.apiEnd, {
      timesheets,
    })
  }

  exportDocument(start?: string, end?: string): Promise<TimesheetsExportDocumentType> {
    return httpClient.post(`${this.apiEnd}/export/csv`, {
      report: {
        type: {
          value: 'csv',
        },
        service: {
          value: 'timesheets',
        },
      },
      parameters: {
        date: {
          startAt: {
            value: start,
          },
          endAt: {
            value: end,
          },
        },
      },
    })
  }
}
